import React, { useMemo, useState } from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	TermItem,
	useLazyTermItemsQuery,
	useTermItemsQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import useTranslation from '../../../../Hooks/useTranslation';
import Loading from '../../../../Components/Loading';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
}

const CasePrioritySelect: React.FC<Props> = ({ onChange, value }) => {
	const priorityTermItems = useTermItemsQuery({
		termType: 'case_priority',
		take: 999,
	});

	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const tempOptions: SelectValue[] = [
			{ value: '', label: 'base.everything' },
		];

		priorityTermItems?.data?.termItems?.data?.forEach(item => {
			if (item?.name) {
				tempOptions.push({
					label: t(item.name) ?? item.id,
					value: item.id,
				});
			}
		});

		return tempOptions;
	}, [priorityTermItems]);

	if (priorityTermItems.isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			onChange={onChange}
			value={value}
			placeholder={t('base.shared.pick')}
		/>
	);
};
export default CasePrioritySelect;
